<template>
  <div class="row">
    <div class="col-xs-6" >
      <h2 style="margin-top:10px;">{{title}}</h2>
    </div>
    <!-- <div v-show="hide_search != true" class="col-xs-8" style="font-size:12px;">
      <div style="margin:6px 0px;">
        <button :disabled="false" class="btn btn-primary btn-xs" style="float: right;margin-left: 10px;" >クリア</button>
        <input type="checkbox" style="float: right;margin-left: 10px;font-size: 10px;height: 21px;">

        <input class="form-control input-sm" type="text" style="float: right;width:80px;margin-left: 10px;font-size: 10px;height: 21px;">

        <select  class="form-control input-sm" style="float: right;width:80px;font-size: 10px;height: 21px;">
          <option >前方一致</option>
          <option >後方一致</option>
          <option >完全一致</option>
          <option >あいまい検索</option>
        </select>
        <span style="float: right;width:25px;text-align: end;margin-left: 10px;padding-right: 3px;font-size: 13px;">値</span>

        <select  class="form-control input-sm" style="float: right;width:110px;font-size: 10px;height: 21px;">
          <option>機器管理番号</option>
          <option>登録日</option>
          <option>コンピュータ名</option>
          <option>機器所管部署</option>
          <option>機器所管チーム</option>
          <option>機器所管区分</option>
          <option>機器所管システム</option>
          <option>設置部署</option>
          <option>設置チーム</option>
          <option>使用者名</option>
          <option>管理担当者名</option>
        </select>
        <span style="float: right;width:105px;text-align: end;padding-right: 3px;font-size: 13px;">検索情報</span>

      </div>
    </div> -->
  </div>
</template>

<script>
import Vue from "vue";
import debug from "debug";
var debug_search_control = debug("esma:title_and_search");
export default {
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {},
  beforeMount() {},
  mounted() {},
  afterMount() {},
  beforeDestroy() {},
  props: ["title","hide_search"],
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// title_and_search.vue?0fec15ac